// Owner-confirmed cumulative learning metric; distinct from current QBank inventory.
export const QUESTIONS_ANSWERED = 100_000;
export const QUESTIONS_ANSWERED_DISPLAY = `${QUESTIONS_ANSWERED.toLocaleString("en-US")}+`;
